// extracted by mini-css-extract-plugin
module.exports = {"edit-container":"terms-TermsEdit-edit-container-c0a52e7f","editContainer":"terms-TermsEdit-edit-container-c0a52e7f"};